module.exports = __webpack_public_path__ + "static/img/operations.6a4bb9d6.png";